import React from 'react';
import { ConfirmModal } from '../ds/ConfirmModal';
import type { PipelineBuilding } from '../services/api';
import { inaccessibleSentenceText } from '../utils/ceebInaccessiblePush';

/**
 * Potwierdzenie „Wyślij do CEEB z nieobecnościami" (właściciel 2026-10-21, Prusa 28). Okno mówi wprost: które lokale,
 * dokładne zdanie do „Uwag", brak powrotu w CEEB, tylko wersja robocza (wystawia człowiek po sprawdzeniu w CEEB).
 */
export interface InaccessiblePushConfirmProps {
  building: PipelineBuilding | null;
  onConfirm: (b: PipelineBuilding) => void;
  onCancel: () => void;
}

const dzien = (d?: string | null) => {
  if (!d) return null;
  const p = d.split('-');
  return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : d;
};

export function InaccessiblePushConfirm({ building: b, onConfirm, onCancel }: InaccessiblePushConfirmProps) {
  const lokale = b?.inaccessiblePendingCeeb ?? [];
  // Zdanie liczy bot z WSZYSTKICH lokali bez inwentaryzacji (także odmowa wpisu i wysłane wcześniej) — pokazujemy je
  // dosłownie; stary backend bez listy zdania → z lokali do wysłania.
  const doZdania = b?.inaccessibleSentence?.length ? b.inaccessibleSentence : lokale;
  const terminII = dzien(b?.second_term_date ?? null);
  return (
    <ConfirmModal
      open={!!b}
      title={b ? `Wysłać do CEEB z nieobecnościami — „${b.address}”?` : ''}
      message={b ? (
        <div data-testid="inaccessible-push-confirm">
          <p style={{ margin: 0 }}>
            Lokale bez wejścia (nieobecność / odmowa lokatora): <strong>{lokale.join(', ')}</strong>.
            Do CEEB trafią <strong>wyłącznie</strong> jako zdanie w polu „Uwagi” (3. strona protokołu):
          </p>
          <p style={{ margin: '8px 0 0', padding: '8px', background: 'var(--surface-fill)', fontStyle: 'italic' }}>
            {inaccessibleSentenceText(doZdania)}
          </p>
          <p style={{ margin: '8px 0 0' }}>
            Bez inwentaryzacji tych lokali — w CEEB <strong>nie zostanie zapisany powrót</strong> ani ponowna wizyta.
            {terminII ? ` Termin II (${terminII}) zostaje w planie: jeśli lokator wpuści kominiarza, nowy zapis z tabletu wróci do kolejki „Wyślij do CEEB”.` : ''}
          </p>
          {!b.ceebCaseNumber && (
            <p style={{ margin: '8px 0 0' }}>
              Budynek nie ma jeszcze protokołu z tego roku — bot znajdzie albo założy go w CEEB (założonego protokołu nie da się usunąć z aplikacji).
            </p>
          )}
          <p style={{ margin: '8px 0 0' }}>
            <strong>Tylko wersja robocza</strong> — protokół NIE zostanie wystawiony („Wprowadzony”). CEEB może skopiować do niego
            lokale z poprzedniej kontroli z danymi sprzed roku: sprawdź protokół w CEEB i wystaw go ręcznie.
          </p>
        </div>
      ) : ''}
      confirmLabel="Zapisz wersję roboczą"
      onConfirm={() => { if (b) onConfirm(b); }}
      onCancel={onCancel}
    />
  );
}
